import type { FullThread } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";
import type { SuperAgentThread } from "app/pages/sales-intelligence/modules/ai-agent/types/superAgent";
import type {
    ForceResultWithFullResponse,
    GetRequestOptions,
    IFetchService,
    PostConfigObject,
} from "app/services/fetchService";

export default function createSuperAgentApiService(apiClient: IFetchService) {
    return {
        createSuperAgentThread: (
            {
                message,
            }: {
                message: string;
            },
            options?: Readonly<PostConfigObject>,
        ): Promise<ForceResultWithFullResponse<string>> => {
            return apiClient.post(`/sales-api/api/ai-agents/assistant-agent/threads`, { message }, options);
        },
        postSuperAgentMessage: (
            {
                threadId,
                message,
            }: {
                threadId: string;
                message: string;
            },
            options?: Readonly<PostConfigObject>,
        ): Promise<ForceResultWithFullResponse<string>> => {
            return apiClient.post(
                `/sales-api/api/ai-agents/assistant-agent/threads/${threadId}/message`,
                { message },
                options,
            );
        },
        getSuperAgentThreads: (
            options?: Readonly<GetRequestOptions>,
        ): Promise<ForceResultWithFullResponse<{ items: SuperAgentThread[] }>> => {
            return apiClient.get(`/sales-api/api/ai-agents/assistant-agent/threads`, undefined, options);
        },
        getThreadById: (
            { threadId }: { threadId: string },
            options?: Readonly<GetRequestOptions>,
        ): Promise<ForceResultWithFullResponse<Pick<FullThread, "messages">>> => {
            return apiClient.get(`/sales-api/api/ai-agents/assistant-agent/threads/${threadId}`, undefined, options);
        },
        updateMessage: (
            { threadId, messageId, message }: { threadId: string; messageId: string; message: string },
            options?: Readonly<PostConfigObject>,
        ): Promise<ForceResultWithFullResponse<void>> => {
            return apiClient.put(
                `/sales-api/api/ai-agents/assistant-agent/threads/${threadId}/messages/${messageId}`,
                { content: message },
                options,
            );
        },
    };
}
